import { combineReducers } from "redux";
import {
  fetching,
  submitting,
  items,
  togglable,
  selectable,
} from "./resource";

export default combineReducers({
  selectedItem: selectable("teamRoles"),
  isFetching: fetching("teamRoles"),
  isSubmitting: submitting("teamRoles"),
  items: items("teamRoles"),
  showAddModal: togglable("addModal"),
});
